import { axios, base } from '../http';

export const getComputerScreenConfig = (params) => {
  return axios.get(`${base}/api/department/GetComputerScreenConfig`, { params: params });
};

export const saveComputerScreenConfig = (params) => {
  return axios.post(`${base}/api/department/SaveComputerScreenConfig`, params);
};
// 学校数据概览配置

export const getSchoolDataOverviewConfig = (params) => {
  return axios.get(`${base}/api/department/GetSchoolDataOverviewConfig`, { params: params });
};

export const getTeacherDataOverviewConfig = (params) => {
  return axios.get(`${base}/api/department/GetTeacherDataOverviewConfig`, { params: params });
};

export const saveTeacherDataOverviewConfig = (params) => {
  return axios.post(`${base}/api/department/SaveTeacherDataOverviewConfig`, params);
};

// 菜单屏配�?

export const getMenuScreenConfig = (params) => {
  return axios.get(`${base}/api/department/GetMenuScreenConfig`, { params: params });
};

export const saveMenuScreenConfig = (params) => {
  return axios.post(`${base}/api/department/SaveMenuScreenConfig`, params);
};

export const getCampusSceneryList = (params) => {
  return axios.get(`${base}/api/CampusScenery/GetList`, { params: params });
};

export const saveCampusScenery = (params) => {
  return axios.post(`${base}/api/CampusScenery/AddOrUpdate`, params);
};

export const removeCampusScenery = (params) => {
  return axios.get(`${base}/api/CampusScenery/Delete`, { params: params });
};

// 获取大屏班级信息（按年级分组�?

export const getBigScreenClasses = (params) => {
  return axios.get(`${base}/api/BigScreen/GetClasses`, { params: params });
};

// 获取大屏班级画像基础信息

export const getBigScreenClassProfile = (params) => {
  return axios.get(`${base}/api/BigScreen/GetDepartmentInfo`, { params: params });
};

// 班级画像模块
// 1. 班级活动/环境/园地

export const getClassActivityList = (params) => {
  return axios.get(`${base}/api/Class/GetActivityList`, { params: params });
};

export const saveClassActivity = (params) => {
  return axios.post(`${base}/api/Class/AddOrUpdateActivity`, params);
};

export const removeClassActivity = (params) => {
  return axios.get(`${base}/api/Class/DeleteActivity`, { params: params });
};

// 2. 班级公约

export const getClassConventionList = (params) => {
  return axios.get(`${base}/api/Class/GetConventionList`, { params: params });
};

export const saveClassConvention = (params) => {
  return axios.post(`${base}/api/Class/AddOrUpdateConvention`, params);
};

export const removeClassConvention = (params) => {
  return axios.get(`${base}/api/Class/DeleteConvention`, { params: params });
};

// 3. 班级职务

export const getClassDutyList = (params) => {
  return axios.get(`${base}/api/Class/GetDutyList`, { params: params });
};

export const saveClassDuty = (params) => {
  return axios.post(`${base}/api/Class/AddOrUpdateDuty`, params);
};

export const removeClassDuty = (params) => {
  return axios.get(`${base}/api/Class/DeleteDuty`, { params: params });
};

// 4. 班级缩影

export const getClassSnapshotList = (params) => {
  return axios.get(`${base}/api/Class/GetSnapshotList`, { params: params });
};

export const saveClassSnapshot = (params) => {
  return axios.post(`${base}/api/Class/AddOrUpdateSnapshot`, params);
};

export const removeClassSnapshot = (params) => {
  return axios.get(`${base}/api/Class/DeleteSnapshot`, { params: params });
};

export const getBigScreenMenuConfig = (params) => {
  return axios.get(`${base}/api/BigScreen/GetMenuScreenConfig`, { params: params });
};

// 获取学校画像大屏数据（组织架�?+ 校园概况 + 校园风采�?

export const getSchoolProfileData = (params) => {
  return axios.get(`${base}/api/BigScreen/GetSchoolProfileData`, { params: params });
};

// 获取校园新风大屏数据

export const getCampusFreshWindData = (params) => {
  return axios.get(`${base}/api/BigScreen/GetCampusFreshWindData`, { params: params });
};

// 获取教师画像大屏数据（教师概�?+ 分级对比 + 名特�?+ 光荣�?+ 形象墙）

export const getTeacherProfileData = (params) => {
  return axios.get(`${base}/api/BigScreen/GetTeacherProfileData`, { params: params });
};

//获取临时信息列表

export const getAttenBigScreenData = (params) => {
  return axios
    .get(`${base}/api/BigScreen/GetAttenBigScreenData`, { params: params })
    .then((res) => res.data);
};

//请假大屏

export const getLeaveBigScreenData = (params) => {
  return axios
    .get(`${base}/api/BigScreen/GetLeaveBigScreenData`, { params: params })
    .then((res) => res.data);
};

export const GetLeaveOutBigScreenData = (params) => {
  return axios
    .get(`${base}/api/BigScreen/GetLeaveOutBigScreenData`, { params: params })
    .then((res) => res.data);
};

export const GetRealtimeUpdate = (params) => {
  return axios
    .get(`${base}/api/BigScreen/GetDeptLeaveOutFlag`, { params: params })
    .then((res) => res.data);
};

//宿舍大屏

export const getDormBigScreenData = (params) => {
  return axios
    .get(`${base}/api/BigScreen/GetDormBigScreenData`, { params: params })
    .then((res) => res.data);
};

// 德育大屏

export const getBigScreenData = (params) => {
  return axios.get(`${base}/api/BigScreen/GetDismissalBigScreenData`, { params: params });
};

// 获取自定义课程学生规�?
